console.group("inicializando o pack css do app")

import './application.scss'
import './overrides'
import './recyclable'

import './components/main'
import './components/prompt'
import './components/registrations'
import './components/announcements'
import './components/sobre'
import './components/profile'
import './components/notifications'
import './components/contracts'
import './responsive'

console.groupEnd()
